import React from "react";
import { Container, Col, Row} from "reactstrap";
import CardBox from "../CardBox";
import { IWhiteBoxesWrapper } from "../../../Interfaces/shared";


const WhiteBoxesWrapper = ({subtitle,title,boxes,boxLayout}: IWhiteBoxesWrapper) => {

  const isOddCol = !!(boxes.length % 2);
  
  return (
    <div className={`${boxLayout} boxes-wrapper`}>
      <section className="section py-5">
        <div className="text-center mb-5">
          <div className="small-title">{subtitle}</div>
          <h4>{title}</h4>
        </div>
        <Container>
          <Row>
            {boxes.map((box, index) => <Col key={index} xl={isOddCol && boxes.length - 1 === boxes.lastIndexOf(box) ? 8 : 4} className="mb-4">
              <CardBox icon={box.icon.src} title={box.title} description={box.description} />
            </Col>)}
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default WhiteBoxesWrapper;
